import Parent from "parentjs/controllers/article_expandable_controller.js";
export default Parent;
